module.exports = __webpack_public_path__ + "img/mobile-crane.93ad208.png";